import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// récupérer tous les visiteurs
export const searchAll = async (query, context) => {
  const response = await axios.get(apiPaths.baseUrl + "/api/search/all", {
    params: {
      query,
    },
    headers: setHeaders(context),
  });
  return response.data;
};
